import { useMediaQuery } from "@mui/material";
import React from "react";

const useScreenSize = () => {
  const [vertical, setVertical] = React.useState<boolean>(window.innerHeight > window.innerWidth);

  const extraSmall = true;
  const small = useMediaQuery("(min-width: 600px)");
  const medium = useMediaQuery("(min-width: 960px)");
  const large = useMediaQuery("(min-width: 1280px)");
  const extraLarge = useMediaQuery("(min-width: 1536px)");

  const verticalExtraSmall = useMediaQuery("(max-height: 400px)");
  const verticalSmall = useMediaQuery("(max-height: 600px)");
  const verticalMedium = useMediaQuery("(max-height: 960px)");
  const verticalLarge = useMediaQuery("(max-height: 1280px)");
  const verticalExtraLarge = useMediaQuery("(max-height: 1536px)");

  React.useEffect(() => {
    const handleResize = () => {
      setVertical(window.innerHeight > window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { extraSmall, small, medium, large, extraLarge, vertical,
    verticalExtraSmall, verticalSmall, verticalMedium, verticalLarge, verticalExtraLarge };
};

export { useScreenSize };
